import { cn } from 'utils/bem';

export const collapsible = cn('collapsible');
